import { Component, HostBinding, ViewEncapsulation, Input } from '@angular/core';
import { BaseDirective } from '../../../../base.directive';

@Component({
    selector: 'eui-page-footer',
    templateUrl: './eui-page-footer.component.html',
    // changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiPageFooterComponent extends BaseDirective {
    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-page-footer'),
        ].join(' ').trim();
    }
    @HostBinding('attr.data-e2e') @Input() e2eAttr: string = 'eui-page-footer';

    constructor( ) {
        super();
    }
}
